import { apiService } from '../../APIService';
import criteriaService from './criteria';
import criterionGroupsService from './criterion-groups';
import appraisalsService from './appraisals';
import commentsService from './comments';

export default {
  criteria: criteriaService,
  criterionGroups: criterionGroupsService,
  appraisals: appraisalsService,
  comments: commentsService,

  getAllExperts(params) {
    return apiService.get('/experts', params);
  },

  createExpert(payload) {
    return apiService.post('/experts', payload);
  },

  getAllPublicExperts(params) {
    return apiService.get('public/experts', params);
  },

  /**
   * Получение списка экспертов
   * @param  {Number} id мероприятия
   * @param {any} params
   */
  getExperts(id, params) {
    return apiService.get(`/events/${id}/experts`, params);
  },

  /**
   * Публичный запрос на получение списка экспертов у мероприятия
   * @param  {Number} id мероприятия
   * @param {any} params
   */
  getPublicExperts(id, params) {
    return apiService.getCached(`public/events/${id}/experts`, params);
  },

  /**
   * Прикрепление эксперта к мероприятию
   * @param  {Number} id мероприятия
   * @param {any} params
   */
  attachExperts(id, params) {
    return apiService.put(`/events/${id}/experts/attach`, params);
  },

  /**
   * Открепление эксперта от мероприятия
   * @param  {Number} id мероприятия
   * @param {any} params
   */
  detachExperts(id, params) {
    return apiService.put(`/events/${id}/experts/detach`, params);
  },

  /**
   * Изменения заданий в связке эксперта, мероприятия, и номинации
   * @param {Object} params { "poll_ids": [] }
   */
  attachExpertPoll(eventId, expertId, nominationId, params) {
    return apiService.put(`/events/${eventId}/experts/${expertId}/nominations/${nominationId}/poll-ids`, params);
  },

  /**
   * Получение списка экспертиз
   * @param {any} params
   */
  getExpertises(params) {
    return apiService.get('/expertises', params);
  },

  /**
   * Создание экспертизы
   * @param {any} params
   */
  createExpertises(params) {
    return apiService.post('/expertises', params);
  },
  getExpertsRequests(params) {
    return Promise.reject(new Error('Бэкенд больше не поддерживает список expert requests'));
  },

  getInvitedExperts(params) {
    return Promise.reject(new Error('Бэкенд больше не поддерживает organizer expert requests'));
  },
  sendInvitedExperts(params) {
    return Promise.reject(new Error('Бэкенд больше не поддерживает отправку expert requests'));
  },
  cancelInviteExpert(params) {
    return Promise.reject(new Error('Бэкенд больше не поддерживает отмену expert requests'));
  },
  cancelInvite(params) {
    return Promise.reject(new Error('Бэкенд больше не поддерживает отмену expert requests'));
  },
  acceptInvite(params) {
    return Promise.reject(new Error('Бэкенд больше не поддерживает принятие expert requests по request_id'));
  },

  confirmExpertise(id, params) {
    return apiService.post(`expertises/${id}/complete`, params);
  },

  // Критерий для оценкци работ

  expertiseCriterionGroupAdd(id, params) {
    return apiService.post(`/expertise-criterion-groups/${id}/add`, params);
  },

  expertiseCriterionGroupRemove(id, params) {
    return apiService.post(`/expertise-criterion-groups/${id}/remove`, params);
  },
};
